export default "__VITE_ASSET__r2E2vAJk__"